import clsx from 'clsx';

export function CheckboxUncheckedIcon({ className }) {
  return (
    <svg
      className={clsx(className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="1" y="1" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
